/* eslint-disable no-underscore-dangle */
const getFromConfig = key => {
  if (typeof window !== 'undefined' && '__env__' in window && key in window.__env__) {
    return window.__env__[key];
  }
  return process.env[key];
};

export default getFromConfig;
